import * as React from "react";

function RedPinIcon(props) {
  return (
    <svg
      width="40"
      height="44"
      viewBox="0 0 40 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 0.34375C11.5566 0.34375 4.6875 7.89981 4.6875 17.1875C4.6875 21.6992 7.17242 27.4931 12.0732 34.4075C14.3185 37.5671 16.75 40.5612 19.352 43.3703C19.5265 43.5538 19.7586 43.6562 20 43.6562C20.2414 43.6562 20.4735 43.5538 20.648 43.3703C23.25 40.5612 25.6815 37.5671 27.9268 34.4075C32.8276 27.4931 35.3125 21.6992 35.3125 17.1875C35.3125 7.89981 28.4434 0.34375 20 0.34375ZM20 29.2188C13.9688 29.2188 9.0625 23.8219 9.0625 17.1875C9.0625 10.5531 13.9688 5.15625 20 5.15625C26.0312 5.15625 30.9375 10.5531 30.9375 17.1875C30.9375 23.8219 26.0312 29.2188 20 29.2188Z"
        fill="#D7365A"
      />
      <path
        d="M27.5056 15.7369L20.6306 8.86193C20.458 8.68937 20.2332 8.59375 20 8.59375C19.7668 8.59375 19.5419 8.68937 19.3694 8.86193L12.4944 15.7369C12.3342 15.8971 12.2293 16.1134 12.1976 16.3489C12.1658 16.5845 12.2091 16.8249 12.3201 17.0293C12.4077 17.185 12.5305 17.313 12.6764 17.401C12.8224 17.489 12.9866 17.5338 13.153 17.5312H14.0625V24.0625C14.0625 24.336 14.1613 24.5983 14.3371 24.7917C14.5129 24.9851 14.7513 25.0937 15 25.0937H17.1875C17.4361 25.0937 17.6746 24.9851 17.8504 24.7917C18.0262 24.5983 18.125 24.336 18.125 24.0625V20.2812C18.125 20.0077 18.2238 19.7454 18.3996 19.552C18.5754 19.3586 18.8138 19.25 19.0625 19.25H20.9375C21.1861 19.25 21.4246 19.3586 21.6004 19.552C21.7762 19.7454 21.875 20.0077 21.875 20.2812V24.0625C21.875 24.336 21.9738 24.5983 22.1496 24.7917C22.3254 24.9851 22.5638 25.0937 22.8125 25.0937H25C25.2486 25.0937 25.4871 24.9851 25.6629 24.7917C25.8387 24.5983 25.9375 24.336 25.9375 24.0625V17.5312H26.847C27.0134 17.5338 27.1776 17.489 27.3235 17.401C27.4695 17.313 27.5922 17.185 27.6798 17.0293C27.7908 16.8249 27.8341 16.5845 27.8024 16.3489C27.7706 16.1134 27.6658 15.8971 27.5056 15.7369Z"
        fill="#D7365A"
      />
    </svg>
  );
}

export default RedPinIcon;
